import React from "react";
import { useQuery, gql } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@material-ui/core";

import { KeyValueArray } from "./KeyValueArray";

const GET_COLLEGE_INFO = gql`
  query Query($getCollegeInfoCollegeId: String) {
    getCollegeInfo(collegeId: $getCollegeInfoCollegeId)
  }
`;

export function CampusLife() {
  const { collegeId } = useParams();

  const { loading, error, data } = useQuery(GET_COLLEGE_INFO, {
    fetchPolicy: "cache-first",
    variables: {
      getCollegeInfoCollegeId: collegeId,
    },
  });

  if (loading) {
    return (
      <Box>
        <CircularProgress style={{ color: "#3699FF" }} />
      </Box>
    );
  }

  let collegeDetails = !error ? JSON.parse(data.getCollegeInfo) : {};

  const basicInfo = [
    {
      key: "typicalRoomAndBoard",
      value: collegeDetails.typicalRoomAndBoard,
    },
    {
      key: "onCampusHousingAvailable",
      value: collegeDetails.onCampusHousingAvailable,
    },
    {
      key: "fraternitiesPercentParticipation",
      value: collegeDetails.fraternitiesPercentParticipation,
    },
    {
      key: "freshmenLiveOnCampus",
      value: collegeDetails.freshmenLiveOnCampus,
    },
    {
      key: "freshmenRequiredToLiveOnCampus",
      value: collegeDetails.freshmenRequiredToLiveOnCampus,
    },
    { key: "mealPlanAvailable", value: collegeDetails.mealPlanAvailable },
    {
      key: "percentFirstGeneration",
      value: collegeDetails.percentFirstGeneration,
    },
    { key: "primaryFaith", value: collegeDetails.primaryFaith },
    {
      key: "religiousAffiliation",
      value: collegeDetails.religiousAffiliation,
    },
    {
      key: "sororitiesPercentParticipation",
      value: collegeDetails.sororitiesPercentParticipation,
    },
    { key: "undergraduateSize", value: collegeDetails.undergraduateSize },
  ];

  const rankings = [
    {
      key: "rankingsBestStudentLife",
      value: collegeDetails.rankingsBestStudentLife,
    },
    {
      key: "rankingsBestCollegeFood",
      value: collegeDetails.rankingsBestCollegeFood,
    },
    {
      key: "rankingsBestGreekLifeColleges",
      value: collegeDetails.rankingsBestGreekLifeColleges,
    },
    {
      key: "rankingstopPartySchools",
      value: collegeDetails.rankingstopPartySchools,
    },
  ];

  return (
    <>
      <Card className="mb-5">
        <CardContent>
          <Typography variant="h4" className="text-center" color="primary">
            {collegeDetails.name + " Campus Life"}
          </Typography>
        </CardContent>
      </Card>

      <Card className="mb-5">
        <CardContent>
          <Grid container spacing={8}>
            <Grid item sm={6}>
              <KeyValueArray
                data={basicInfo.slice(0, Math.ceil(basicInfo.length / 2))}
              />
            </Grid>
            <Grid item sm={6}>
              <KeyValueArray
                data={basicInfo.slice(Math.ceil(basicInfo.length / 2))}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Grid container>
        <Grid item xs={12} sm={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" className="text-center" color="primary">
                Rankings
              </Typography>
              <KeyValueArray data={rankings} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
